import React, { createContext, useState, useContext, useCallback } from 'react';

const LoadingContext = createContext(null);

export const LoadingProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState('');

  const showLoading = useCallback((message = '') => {
    setLoadingCount(prev => prev + 1);
    if (message) setLoadingMessage(message);
  }, []);

  const hideLoading = useCallback(() => {
    setLoadingCount(prev => {
      const newCount = Math.max(0, prev - 1);
      // Clear message when all loading is done
      if (newCount === 0) {
        setLoadingMessage('');
      }
      return newCount;
    });
  }, []);

  // Ensure isLoading is always a boolean
  const isLoading = loadingCount > 0;

  const value = {
    isLoading,
    showLoading,
    hideLoading,
    loadingMessage
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    // Return safe defaults if context not available
    return {
      isLoading: false,
      showLoading: () => {},
      hideLoading: () => {},
      loadingMessage: ''
    };
  }
  return context;
};

export default LoadingContext;
